import * as React from 'react';

import {
  FooterBoxProps,
} from './footerboxprops';

/**
 * Footer  dispalyed at bottom of page contians two sections
 * @mainblock contains left most items passed with group of  JSX Elements
 * @sideblock contains right most items passed with  JSX Elements encolsed in footersideitems tag
 */
export const FooterBox = ({
  mainblock,
  sideblock,
  sideClassName = 'footer-box__aside',
  mainClassName = 'footer-box__main',
}: FooterBoxProps) => (
    <div className='footer-box'>
      <div className={mainClassName}>
        {mainblock}
      </div>
      <div className={sideClassName}>
        <div className="footer-nav">
          <div className="footer-nav__list">
            {sideblock}
          </div>
        </div>

      </div>
    </div>
  );
